<ng-template #cellRendererTmpl let-record="record" let-column="column">
  <!-- uncomment to have compiler check template types
  <ng-container *ngIf="typedRecord(record); let record">
  <ng-container *ngIf="typedColumn(column); let column">
  -->
  <ng-container [ngSwitch]="column.name">

    <td *ngSwitchCase="'pathId'">      
      <a href="javascript:false" 
        (click)="volPtTable.showPath(record)">{{
          record[column.name]
      }}</a>
    </td>

    <td *ngSwitchCase="'pointId'">      
      <a href="javascript:false" 
        (click)="volPtTable.showTab('point',record.pointId)">{{
          record[column.name]
      }}</a>
    </td>

    <!-- did not find a cell renderer by column name so now try template type -->
    <ng-container *ngSwitchDefault [ngSwitch]="column.template">
      <td *ngSwitchCase="'userLink'">      
        <a *ngIf="roleMgr.isAdmin||roleMgr.canAssignScheduler||roleMgr.canSchedule else noEdit"
          href="javascript:false" 
          (click)="volPtTable.editVolunteer(record)">{{
            record[column.name]
        }}</a>
        <ng-template #noEdit>
          {{ record[column.name] }}
        </ng-template>
      </td>

      <td *ngSwitchCase="'buildingLink'">      
        <a href="javascript:false" 
          (click)="volPtTable.showBuilding(record)">{{
            record[column.name]
        }}</a>
      </td>

      <td
        *ngSwitchDefault
        fes-table-view-default-cell-renderer
        [column]="column"
        [record]="record"
        [tableComponent]="volPtTable"
      ></td>
    </ng-container>
  </ng-container>

</ng-template>

<app-volunteer-points-table
  [cellRendererTmplRef]="cellRendererTmpl"
  [tabConfig]="tabConfig"
  [detailFn]="detailFn"
  [isActiveView]="tabConfig.active"
  [contextJson]="tabConfig.viewInfo.id"
  (contextJsonChange)="contextJsonChangeHandler($event, tabConfig)"
  #volPtTable
>
</app-volunteer-points-table>
